export default "__VITE_ASSET__DALo31_K__"